import { Drawer, SimpleToolbar, Loader, Toast } from "../../../components";
import {
  Grid,
  Container,
  makeStyles,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Box,
  Tooltip,
  Typography,
  Button,
  Hidden,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Chip,
  Card,
  CardContent,
} from "@material-ui/core";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useEffect, useState } from "react";
import { CustomTable } from "../../../components/custom-table";
import {
  ArrowForwardRounded,
  CreateRounded,
  DeleteOutlineRounded,
} from "@material-ui/icons";
import { ToggleStatus } from "../../../components/toggle-status";
import { useHistory, Link } from "react-router-dom/cjs/react-router-dom.min";
import { FilterSelector } from "../../../components/filter-selector";
import { laboratoryServices } from "../../../services";
import { ConfirmationDialog } from "../../../components/confirmation-dialog";

export default function RepresentativesScreen() {
  const classes = useStyles();
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  // options--> all, active, inactive
  // const [selectionType, setSelectionType] = useState("");
  const [labRepresentative, setLabRepresentative] = useState([]);
  const [representativeToDelete, setRepresentativeToDelete] = useState(null);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  // const [dbZones, setzones] = useState([]);

  // const handleSelectOption = (option) => {
  //   setSelectionType(option);
  // };
  const getFilteredZone = (toFilter) => {
    return toFilter;
  };

  // must be a promise
  const handleChangeZoneStatus = async (newStatus, rep) => {
    const labRepresentativeInfo = {
      ...rep,
      zones: rep.zones.map((z) => z.visitingZoneInfo._id),
      status: newStatus ? "active" : "inactive",
    };
    try {
      const { status, response } =
        await laboratoryServices.updateLabRepresentative({
          labRepresentativeInfo,
          token: authState.token,
        });
      setToast(true);
      if (status === 200) {
        getLabRepresentatives();
        setToastMessage(response.response.message);
      } else throw new Error("");

      // console.log(response);
    } catch (error) {
      console.log("error on Deleting zone", error);
      throw new Error("");
    }
  };

  const handleDeleteRepresentative = async () => {
    handleConfirmationDialog({}, "close");
    try {
      setLoading(true);
      const { status, response } =
        await laboratoryServices.deleteLabRepresentative({
          labRepresentativeId: representativeToDelete._id,
          token: authState.token,
        });
      setToast(true);
      setToastMessage(response.response.message);
      if (status === 200) {
        getLabRepresentatives();
      }
      // console.log(response);
    } catch (error) {
      console.log("error on Deleting zone", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmationDialog = (representative, type) => {
    if (type === "open") {
      setOpenConfirmationDialog(true);
      setRepresentativeToDelete(representative);
    }
    if (type === "close") {
      setOpenConfirmationDialog(false);
      setRepresentativeToDelete(null);
    }
  };

  async function getLabRepresentatives() {
    setLoading(true);
    laboratoryServices
      .findLabRepresentativesByLaboratory({
        laboratoryId: authState.user.laboratory._id,
        token: authState.token,
      })
      .then((res) => {
        if (res.status === 200) {
          setLabRepresentative(res.response.response || []);
          // console.log(res.response.response);
        } else {
          setToast(true);
          setToastMessage("Ha ocurrido un error.");
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    getLabRepresentatives();
  }, []);

  // useEffect(() => {
  //   async function getVisitingZones() {
  //     setLoading(true);
  //     laboratoryServices
  //       .getVisitingZones({
  //         laboratoryId: authState.user.laboratory._id,
  //         token: authState.token,
  //       })
  //       .then((res) => {
  //         if (res.status === 200) {
  //           setzones(res.response.response || []);
  //           // console.log(res.response.response);
  //         } else {
  //           setToast(true);
  //           setToastMessage("Ha ocurrido un error.");
  //         }
  //       })
  //       .catch((e) => console.error(e))
  //       .finally(() => setLoading(false));
  //   }
  //   getVisitingZones();
  // }, []);
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {/* {loading && <Loader loading={true} />} */}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              onFilter={(toFilter) => getFilteredZone(toFilter)}
              noSearchBar
            />
          </Container>
          <Container maxWidth={"lg"} component={"main"}>
            <Hidden xsDown>
              <Box className={classes.header_table}>
                <Button
                  variant="text"
                  color="default"
                  component={Link}
                  to="/zones/representative/create"
                >
                  <span>Nuevo Representante</span>
                  <ArrowForwardRounded fontSize="small" />{" "}
                </Button>
              </Box>
            </Hidden>
            {isMobile && (
              <Box className={classes.header_table_mobile}>
                {labRepresentative?.length ? (
                  <Box className={classes.header_table_mobile_checkbox}>
                    {/* <FilterSelector
                      options={[
                        { label: "Todos", value: "all" },
                        { label: "Activos", value: "active" },
                        { label: "Inactivos", value: "inactive" },
                      ]}
                      selectedOption={selectionType}
                      onHandleSelectOption={handleSelectOption}
                    /> */}
                  </Box>
                ) : null}
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to="/representative/create"
                  style={{ textTransform: "none" }}
                >
                  Nuevo Representante
                </Button>
              </Box>
            )}
            <CustomTable
              propsTable={{ id: "ZonesTable", style: { tableLayout: "fixed" } }}
            >
              {/* {selectedZones.length ? (
                <CustomCaption>
                  <Box className={classes.toolbar}>
                    <Typography>
                      {selectedZones.length} seleccionados
                    </Typography>
                    <Box display="flex" style={{ gap: 12, flexWrap: "wrap" }}>
                      {visibleAssigmentAllButton &&
                        selectedZones.length > 1 && (
                          <Tooltip
                            title="Asignar seleccionados"
                            placement="top"
                            arrow
                          >
                            <IconButton
                              color="inherit"
                              onClick={() => {
                                // history.push("/zones/assignment");
                              }}
                            >
                              <ReplyAllRounded
                                style={{ transform: "rotateY(180deg)" }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}

                      <Tooltip
                        title="Eliminar seleccionados"
                        placement="top"
                        arrow
                      >
                        <IconButton color="inherit">
                          <DeleteForever />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </CustomCaption>
              ) : null} */}
              <TableHead>
                <TableRow>
                  {/* <TableCell component="th" style={{ width: "5%" }}>
                    {!isMobile && (
                      <FilterSelector
                        options={[
                          { label: "Todos", value: "all" },
                          { label: "Activos", value: "active" },
                          { label: "Inactivos", value: "inactive" },
                        ]}
                        selectedOption={selectionType}
                        onHandleSelectOption={handleSelectOption}
                        disabled={!labRepresentative.length}
                      />
                    )}
                  </TableCell> */}
                  <TableCell component="th" style={{ width: "40%" }}>
                    Nombre
                  </TableCell>
                  <TableCell component="th" style={{ width: "20%" }}>
                    Estado
                  </TableCell>
                  <TableCell component="th" style={{ width: "20%" }}>
                    Zonas
                  </TableCell>
                  <TableCell component="th" style={{ width: "20%" }}>
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!labRepresentative?.length && !loading && (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }} colSpan={100}>
                      No hay datos que correspondan con su búsqueda
                    </TableCell>
                  </TableRow>
                )}
                {loading && (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }} colSpan={100}>
                      <CircularProgress color="secondary" size={40} />
                    </TableCell>
                  </TableRow>
                )}
                {labRepresentative?.map((rep) => {
                  const dbStatus = rep.status;
                  const {
                    _id,
                    firstName,
                    lastName,
                    email,
                    phone,
                    rut,
                    laboratoryId,
                    zones,
                  } = rep;
                  const status = dbStatus === "active";
                  return (
                    <TableRow
                      key={`row-zone-${_id}`}
                      data-status={status ? "active" : "inactive"}
                    >
                      {/* <TableCell style={{ gridColumn: "span 2", order: "-1" }}>
                        <Checkbox
                          disabled={!status}
                          checked={selectedZones.includes(_id)}
                          className={classes.checkbox_table}
                          aria-label="Seleccionar zona"
                          onChange={(e) =>
                            handleSelectedZones({
                              checked: e.target.checked,
                              id: _id,
                            })
                          }
                        />
                      </TableCell> */}
                      <TableCell
                        style={{
                          textTransform: "capitalize",
                          gridColumn: "span 3",
                          textAlign: "center",
                          ...(!status && { opacity: "0.5" }),
                        }}
                      >
                        {`${firstName} ${lastName}`}
                      </TableCell>
                      <TableCell style={{ order: "-1" }}>
                        <ToggleStatus
                          active={status}
                          onClick={(newStatus) =>
                            handleChangeZoneStatus(newStatus, rep)
                          }
                        />
                      </TableCell>
                      <TableCell
                        style={{
                          textTransform: "capitalize",
                          gridColumn: "span 3",
                          textAlign: "center",
                          overflow: "auto",
                          ...(!status && { opacity: "0.5" }),
                        }}
                      >
                        {zones.length < 1
                          ? null
                          : zones.map((zone) => {
                              const labelZone =
                                zone?.visitingZoneInfo?.name || "N/A";
                              return (
                                <Chip
                                  key={zone._id}
                                  size="small"
                                  label={labelZone}
                                  style={{ wordBreak: "break-all" }}
                                />
                              );
                            })}
                      </TableCell>
                      <TableCell style={{ gridColumn: "span 3" }}>
                        <Box className={classes.action_buttons}>
                          <Tooltip title="Editar zona" placement="top" arrow>
                            <Button
                              component={Link}
                              style={{ boxShadow: "none" }}
                              variant="outlined"
                              color="secondary"
                              to={`/zones/representative/update/${_id}`}
                            >
                              <Typography component="span">Editar</Typography>
                              <CreateRounded fontSize="small" />
                            </Button>
                          </Tooltip>
                          <Tooltip
                            title="Eliminar representante"
                            placement="top"
                            arrow
                          >
                            <Button
                              style={{ boxShadow: "none" }}
                              variant="outlined"
                              color="default"
                              onClick={() =>
                                handleConfirmationDialog(
                                  {
                                    _id,
                                    fullName: `${firstName} ${lastName}`,
                                    rut,
                                    email,
                                  },
                                  "open"
                                )
                              }
                            >
                              <Typography component="span">Eliminar</Typography>
                              <DeleteOutlineRounded fontSize="small" />
                            </Button>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </CustomTable>
            <ConfirmationDialog
              open={openConfirmationDialog}
              onClose={() => handleConfirmationDialog({}, "close")}
              onConfirm={handleDeleteRepresentative}
              title={"Eliminar representante"}
            >
              <Box>
                <Typography>¿Está seguro que desea eliminar?</Typography>
                <Card style={{ marginBlock: 12 }} elevation={2}>
                  <CardContent>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      Representante
                    </Typography>
                    <Typography variant="h5" component="h2">
                      {representativeToDelete?.fullName}
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                      {representativeToDelete?.rut}
                    </Typography>
                    <Typography variant="body2" component="p">
                      {representativeToDelete?.email}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </ConfirmationDialog>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    "& main": {
      flexGrow: 1,
    },
    "& table tbody tr": {
      [theme.breakpoints.only("xs")]: {
        backgroundColor: `hsl(from ${theme.palette.primary.light} h s calc(l + 54))`,
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
        border: "none",
        borderRadius: theme.spacing(2),
        '&[data-status="inactive"]': {
          backgroundColor: theme.palette.grey[100],
        },
      },
    },
    "& .MuiPaper-root": {
      boxShadow: "none !important",
    },
  },
  checkbox_table: { padding: 0 },
  header_table: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: "-10px",
    marginTop: 12,
    "& a": {
      textTransform: "none",
      width: "30%",
      maxWidth: 150,
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
  },
  header_table_mobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "-10px",
    marginTop: 16,
  },
  header_table_mobile_checkbox: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: theme.palette.text.primary,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.5rem 1rem",
    color: "inherit",
  },
  action_buttons: {
    width: "100%",
    display: "flex",
    gap: 12,
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    "& button, & a": {
      textTransform: "none",
      flexGrow: 1,
      [theme.breakpoints.up("sm")]: {
        maxWidth: 120,
      },
    },
  },
}));
